import is from '@sindresorhus/is';
import hotkeys from 'hotkeys-js';
import { useEffect, useRef } from 'react';

export type HotkeyBinding = {
    readonly enabled: boolean;
    readonly hotkey: string | undefined;
    readonly onTrigger: (event: KeyboardEvent) => void;
    readonly scope: string | undefined;
};

export const hotkeyCombination = (hotkey: string): string => {
    const key = hotkey.toLowerCase();

    return `cmd+${key},ctrl+${key}`;
};

export const useHotkey = ({ enabled, hotkey, onTrigger, scope }: HotkeyBinding): void => {
    const triggerRef = useRef(onTrigger);

    useEffect(() => {
        triggerRef.current = onTrigger;
    }, [onTrigger]);

    useEffect(() => {
        if (!enabled || is.nullOrUndefined(hotkey) || is.nullOrUndefined(scope)) {
            return;
        }

        const combination = hotkeyCombination(hotkey);
        const handler = (event: KeyboardEvent): void => triggerRef.current(event);

        hotkeys.setScope(scope);
        hotkeys(combination, scope, handler);

        return () => {
            hotkeys.unbind(combination, scope, handler);
        };
    }, [enabled, hotkey, scope]);
};
